import React from 'react'
import PropTypes from 'prop-types'
import { Spinner as NuiSpinner } from '@theneatcompany/nui'
import cx from 'classnames'

import styles from './FullScreenSpinner.module.scss'

const Spinner = ({
  size = null,
  className = '',
  secondary = false,
  children,
  value,
  intent,
  small,
  large,
}) => (
  <div className={cx(styles.container, secondary && styles.isSecondary, className)} data-testid="load-spinner">
    <div className={styles.billingSubmitting}>
      <NuiSpinner
        className={className}
        intent={intent}
        large={large}
        size={size}
        small={small}
        value={value}
      />
      {children}
    </div>
  </div>
)

Spinner.PropType = {
  size: PropTypes.number,
  value: PropTypes.number,
  className: PropTypes.string,
  secondary: PropTypes.bool,
  children: PropTypes.func,
  small: PropTypes.bool,
  large: PropTypes.bool,
}

export default Spinner
